const reportAuthAction = ({ actionName, user = {}, source, emailOnly }) => {
    if (window.newrelic && typeof window.newrelic.addPageAction === 'function') {
        let actionPayload = {
            source,
            userId: user.serviceId,
            location: window.location.href,
        };

        if (typeof emailOnly === 'boolean') {
            actionPayload = {
                ...actionPayload,
                emailOnly,
            };
        }

        window.newrelic.addPageAction(actionName, actionPayload);
    }
};

export const reportLoginAction = ({ user, source } = {}) => {
    reportAuthAction({
        actionName: 'dbl:login',
        user,
        source,
    });
};

export const reportRegisterAction = ({ user, source, emailOnly } = {}) => {
    reportAuthAction({
        actionName: 'dbl:register',
        user,
        source,
        emailOnly,
    });
};
